import Box from '@mui/material/Box';
import { Text } from '../../../Atoms/Text';

interface FieldErrorProps {
  id: string;
  message: string;
}

export const FieldError = ({ id, message }: FieldErrorProps) => (
  <Box
    id={id}
    role="alert">
    <Text
      size="sm"
      color="red">
      {message}
    </Text>
  </Box>
);
